import { useEffect, useState } from 'react';
import { FaArrowRight, FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logoGreen from '../assets/images/logo-green.svg';
import {
  LogoMobile,
  MenuWrapperMobileNew,
  MenuWrapperNew,
  NavMenu,
  NavbarStyles,
  ToggleButton,
} from './Navbar.styles';
import { HeaderWrapper } from '../pages/Home.styles';
import { AnimatedLogo } from './AnimatedLogo';
import MobileMenu from '../common/MobileMenu';

function Navbar() {
  const [shadow, setShadow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 65) {
        setShadow(true);
      } else {
        setShadow(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <HeaderWrapper shadow={shadow}>
      <NavbarStyles>
        <MenuWrapperNew>
          <NavMenu className="d-flex align-items-center justify-content-start gap-4">
            <ul className="mb-0 ps-0">
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.8, ease: 'linear' }}
                viewport={{ once: true }}
                className="pb-0"
              >
                <Link to="/soluzioni">Soluzioni</Link>
              </motion.li>
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4, duration: 0.8, ease: 'linear' }}
                viewport={{ once: true }}
                className="pb-0"
              >
                <a href="/blog">Blog</a>
              </motion.li>
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2, duration: 0.8, ease: 'linear' }}
                viewport={{ once: true }}
                className="pb-0"
              >
                <a href="/collabora-con-noi">Collabora Con Noi</a>
              </motion.li>
              {/* <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, ease: 'linear' }}
                viewport={{ once: true }}
                className="pb-0"
              >
                <a href="/team">Team</a>
              </motion.li> */}
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, ease: 'linear' }}
                viewport={{ once: true }}
                className="pb-0"
              >
                <a href="/servizio-whatsapp">Servizio WhatsApp</a>
              </motion.li>
            </ul>
          </NavMenu>
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'linear' }}
            viewport={{ once: true }}
            className="position-relative"
          >
            <AnimatedLogo />
          </motion.div>
          <NavMenu className="d-flex align-items-center justify-content-end gap-4">
            <motion.a
              initial={{ y: -100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: 'linear' }}
              viewport={{ once: true }}
              href="https://intermediari.greenia.it"
              target="_blank"
              className="bookmarkBtnBroker text-decoration-none"
              rel="noreferrer"
            >
              <span className="IconContainerBroker">
                <FaArrowRight className="text-dark" />
              </span>
              <p className="text-broker m-0 me-2">Area Intermediari</p>
            </motion.a>
            <motion.div
              initial={{ y: -100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8, ease: 'linear' }}
              viewport={{ once: true }}
            >
              <Link
                to="/login"
                className="bookmarkBtn text-decoration-none"
                rel="noreferrer"
              >
                <span className="IconContainer">
                  <FaArrowRight className="text-white" />
                </span>
                <p className="text m-0 me-2">Area Clienti</p>
              </Link>
            </motion.div>
          </NavMenu>
        </MenuWrapperNew>
        <MenuWrapperMobileNew>
          <div className="d-flex align-items-center justify-content-between">
            <LogoMobile href="/">
              <img src={logoGreen} alt="Greenia SLR" width={150} />
            </LogoMobile>
            <ToggleButton data-bs-toggle="offcanvas" href="#offcanvasExample" role="button" aria-controls="offcanvasExample">
              <FaBars />
            </ToggleButton>
          </div>
        </MenuWrapperMobileNew>

        <MobileMenu />
      </NavbarStyles>
    </HeaderWrapper>
  );
}

export default Navbar;
